<template>
  <v-card width="100%" tile>
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold black--text" >
        <v-row>
        <v-card>
          <v-img
              height="300px"
              max-width="180px"

              :src="require(`../../images/${persona.img}`)"
          />
        </v-card>
        </v-row>

        <v-row>
        {{persona.name}}
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="text-subtitle-1 black--text pt-0 pb-1" v-for="(item, index) in persona.paragraphs" :key="index">
        <p v-html="item">
        {{item}}
        </p>
      </v-expansion-panel-content>
    </v-expansion-panel>
<!--    <v-card-title class="font-weight-bold black&#45;&#45;text pb-0">{{persona.name}}</v-card-title>-->
<!--    <v-card-text class="text-subtitle-1 black&#45;&#45;text pt-0 pb-1" v-for="(item, index) in persona.paragraphs" :key="index">{{item}}</v-card-text>-->
  </v-card>

</template>

<script>
export default {
  name: "PersonaComponent",
  data () {
    return {

    }
  },

  props: {
    persona: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>